import React, { useState, useContext } from "react";
import styled from "styled-components";
import { MdSearch, MdClear } from "react-icons/md";
import { PastoralContext } from "./../../../contexts/PastoralContext";
import { OrganizationContext } from "./../../../contexts/OrganizationContext";
import { DateRangePicker } from "rsuite";
import { predefinedBottomRanges } from "../../../assets/data";
import { useFormFields } from "../../../contexts/FormFieldsContext";

// SearchComponent
const SearchComponent = (props) => {
  const { context } = props; // Context passed as a prop
  const { searchValue, setSearchValue, filter } = useContext(context);
  const { organizations } = useContext(OrganizationContext);
  const { formFields } = useFormFields();
  const { followUpTypes } = formFields;
  const [selectedRange, setSelectedRange] = useState([]);

  const handleSearch = () => {
    // Handle search logic here
  };

  // Pass the removeValue function into the filter function to return the specified value
  const handleRange = (selectedRange) => {
    console.log("Search query:", selectedRange);
    setSearchValue(selectedRange);
  };

  const handleClear = () => {
    setSearchValue("");
  };

  const organizationOptions = (organizations || []).filter(
    (org) => org.name && org.assignedNumber
  );

  return (
    <>
      {filter === "date_range" ? (
        <DateRange
          id="selectedRange"
          value={searchValue ? searchValue : []}
          ranges={predefinedBottomRanges}
          placeholder="Select Date Range"
          cleanable
          format="yyyy-MM-dd"
          onChange={handleRange}
        />
      ) : filter === "follow_up_type" ? (
        <StyledSelect
          value={searchValue || ""}
          onChange={(e) => setSearchValue(e.target.value)}
        >
          <option value="">Select a Follow Up type</option>
          {followUpTypes.map((followUpType) => {
            return (
              <option
                key={followUpType.id + followUpType.type}
                value={followUpType.type}
              >
                {followUpType.type}
              </option>
            );
          })}
        </StyledSelect>
      ) : filter === "twilio_number" ? (
        <StyledSelect
          value={searchValue || ""}
          onChange={(e) => setSearchValue(e.target.value)}
        >
          <option value="">Select an Organization</option>
          {organizationOptions.map((org) => (
            <option key={org.id || org.name} value={org.assignedNumber}>
              {org.name}
            </option>
          ))}
        </StyledSelect>
      ) : (
        <SearchContainer>
          <SearchIconContainer>
            <SearchIcon />
          </SearchIconContainer>
          <SearchInput
            type="text"
            value={searchValue || ""}
            onChange={(e) => setSearchValue(e.target.value)}
            placeholder={filter === "title" ? "Search by title..." : "Search..."}
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                handleSearch();
              }
            }}
          />
          <SearchIconContainer>
            {searchValue ? <ClearIcon onClick={handleClear} /> : ""}
          </SearchIconContainer>
        </SearchContainer>
      )}
    </>
  );
};

export default SearchComponent;

// Styled-components
const SearchContainer = styled.div`
  display: flex;
  align-items: center;
  border: 1.8px solid #106271;
  border-radius: 30px;
  background-color: white;
  overflow: hidden;
  flex: 1;
  width: 300px;
  max-height: 36px;
  padding-left: 12px;
  padding-right: 4px;
  position: relative;
`;

const SearchInput = styled.input`
  flex: 1;
  border: none;
  outline: none;
  font-family: "Futura PT";
  font-weight: 400;
  font-size: 14px;
  background-color: transparent;
  letter-spacing: 0.15em;
  color: #333;
  min-width: 0;
  padding: 8px 0;

  &::placeholder {
    color: #888;
  }

  &:disabled {
    background-color: #f5f5f5;
    cursor: not-allowed;
  }
`;

const SearchIconContainer = styled.div`
  padding: 0;
  background-color: transparent;
  border: none;
  color: #106271;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  flex-shrink: 0;
  border-radius: 50%;
  transition: all 0.2s ease-in-out;

  &:hover {
    transform: scale(1.05);
  }

  &:active {
    transform: scale(0.95);
  }

  svg {
    width: 20px;
    height: 20px;
  }
`;

const SearchIcon = styled(MdSearch)`
  color: #106271;
`;

const ClearIcon = styled(MdClear)`
  color: #106271;

  &:hover {
    color: #ff4d4d;
  }
`;

const StyledSelect = styled.select`
  padding: 10px 12px;
  border: 2px solid #0d5e6d;
  border-radius: 30px;
  background-color: #0d5e6d;
  color: white;
  font-family: "Futura PT";
  font-size: 14px;
  font-weight: 400;
  letter-spacing: 0.15em;
  outline: none;
  cursor: pointer;
  appearance: none;
  background-image: url("data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='white' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3e%3cpolyline points='6 9 12 15 18 9'%3e%3c/polyline%3e%3c/svg%3e");
  background-repeat: no-repeat;
  background-position: right 12px center;
  background-size: 16px;
  padding-right: 35px;
  width: 100%;
  min-width: 200px;
  box-sizing: border-box;

  &:hover {
    background-color: #0a4a57;
  }

  option {
    background-color: white;
    color: #333;
    padding: 8px;
  }

  @media (min-width: 768px) {
    width: auto;
    min-width: 220px;
  }
`;

const DateRange = styled(DateRangePicker)`
  flex: 1;
  min-width: 0;

  .rs-picker-toggle {
    border: none;
    padding: 8px 12px;
    background: transparent;

    &:hover {
      background: transparent;
    }
  }

  .rs-picker-toggle-wrapper {
    flex: 1;
  }
`;
